import React from 'react';
import ClipboardJS from 'clipboard';
import queryString from 'query-string';

require('../../css/components/ShareDialog.scss');

'use strict';

export default class ShareDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = { copied: false, activeTab: 'share-tab-page' };

        this.setButtonRef = this.setButtonRef.bind(this);
        this.switchActiveTab = this.switchActiveTab.bind(this);
    }

    componentDidMount() {
        this.switchActiveTab('share-tab-page');
    }

    componentWillUnmount() {
        if (this.clipboard)
            this.clipboard.destroy();
    }

    setButtonRef(ref) {
        this.buttonRef = ref;
    }

    switchActiveTab(tab) {
        this.setState({ copied: false, activeTab: tab.target ? tab.target.id : tab });

        if (this.clipboard) {
            this.clipboard.destroy();
            this.clipboard = null;
        }

        if (this.buttonRef)
            this.clipboard = new ClipboardJS(this.buttonRef);
    }

    copyUrlToClipboard(event) {
        this.setState({ copied: true });
    }

    render() {
        var location = this.props.location;

        var urlToShare = window.location.protocol + '//' + window.location.host + location.pathname + (location.search || '');

        var hash;
        var keys;
        var key;

        if (location.hash) {
            hash = queryString.parse(location.hash);

            if (this.props.removeFromHash) {
                keys = Object.keys(this.props.removeFromHash);
                for (key in keys)
                    delete hash[keys[key]];
            }
        }

        if (this.props.addToHash) {
            if (!hash)
                hash = {};

            keys = Object.keys(this.props.addToHash);
            for (key in key)
                hash[keys[key]] = this.props.addToHash[keys[key]];
        }

        if (hash && Object.keys(hash).length)
            urlToShare += '#' + queryString.stringify(hash);

        var body = null;

        if (this.props.sharePlayerEmbedCode) {
            var playerEmbedCode = '<iframe width="640" height="360" frameborder="0" allowfullscreen="1" src="' + window.location.protocol + '//' + window.location.host + this.props.location.pathname.replace("/View/", "/Player/").replace(/\/([^\/]*)$/,'') + '"></iframe>';

            var tabs = React.createElement(
                'ul',
                { className: 'nav nav-tabs', id: 'share-tabs', role: 'tablist' },
                [
                    React.createElement(
                        'li',
                        { className: 'nav-item' },
                        [
                            React.createElement(
                                'a',
                                { className: 'nav-link' + (this.state.activeTab === 'share-tab-page' ? ' active' : ''), id: 'share-tab-page', 'data-toggle': 'tab', href: '#share-tab-content-page', role: 'tab', 'aria-controls': 'share-tab-content-page', 'aria-selected': 'true', onClick: this.switchActiveTab },
                                'Page'
                            )
                        ]
                    ),
                    React.createElement(
                        'li',
                        { className: 'nav-item' },
                        [
                            React.createElement(
                                'a',
                                { className: 'nav-link' + (this.state.activeTab === 'share-tab-player' ? ' active' : ''), id: 'share-tab-player', 'data-toggle': 'tab', href: '#share-tab-content-player', role: 'tab', 'aria-controls': 'share-tab-content-player', 'aria-selected': 'true', onClick: this.switchActiveTab },
                                'Player'
                            )
                        ]
                    )
                ]
            );

            body = React.createElement(
                'div',
                { className: 'tab-content mt-3', id: 'share-tabs-content' },
                [
                    React.createElement(
                        'div',
                        { className: 'tab-pane fade show' + (this.state.activeTab === 'share-tab-page' ? ' active' : ''), id: 'share-tab-content-page', role: 'tabpanel', 'aria-labelledby': 'share-tab-page' },
                        [
                            React.createElement(
                                'div', { className: 'mx-2', key: 'message' }, this.props.copy.pressButtonPage),
                            React.createElement(
                                'textarea', { key: 'url', id: 'share-page', readOnly: true }, urlToShare)
                        ]
                    ),
                    React.createElement(
                        'div',
                        { className: 'tab-pane fade' + (this.state.activeTab === 'share-tab-player' ? ' active' : ''), id: 'share-tab-content-player', role: 'tabpanel', 'aria-labelledby': 'share-tab-player' },
                        [
                            React.createElement(
                                'div', { className: 'mx-2', key: 'message' }, this.props.copy.pressButtonPlayer),
                            React.createElement(
                                'textarea', { key: 'url', id: 'share-player', readOnly: true }, playerEmbedCode)
                        ]
                    )
                ]
            );
        }
        else
            body = [
                React.createElement(
                    'div', { key: 'message' }, this.props.copy.pressButtonPage),
                React.createElement(
                    'textarea', { key: 'url', id: 'share-page', readOnly: true }, urlToShare)
            ];

        return React.createElement(
            'div', { className: 'shareDialog' },
            [
                React.createElement(
                    'div', { key: 'header', className: 'modal-header' },
                    [
                        React.createElement(
                            'button', { key: 'button', type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'close' },
                            React.createElement(
                                'span', { 'aria-hidden': 'true' }, String.fromCharCode(215)))
                    ]
                ),
                React.createElement(
                    'div', { key: 'body', className: 'modal-body' }, [tabs, body]
                ),
                React.createElement(
                    'div', { key: 'footer', className: 'modal-footer' },
                    [
                        React.createElement(
                            'button',
                            {
                                key: 1, type: 'button', className: 'btn btn-success', 'data-clipboard-target': this.state.activeTab === 'share-tab-page' ? '#share-page' : '#share-player', ref: this.setButtonRef,
                                onClick: this.copyUrlToClipboard.bind(this)
                            },
                            this.state.copied ? this.props.copy.copied : this.props.copy.copyToClipboard)
                    ]
                )
            ]
        );
    }
}
